module.exports = __webpack_public_path__ + "static/media/lamina28nota.0d23acff.png";